import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSaveExperiment = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40 40",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group_2214",
		"data-name": "Group 2214",
		transform: "translate(-6 -168)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Icon_feather-save",
			"data-name": "Icon feather-save",
			transform: "translate(11.5 172.5)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_804",
					"data-name": "Path 804",
					d: "M23.167,25.5H6.833A2.333,2.333,0,0,1,4.5,23.167V6.833A2.333,2.333,0,0,1,6.833,4.5H19.667L25.5,10.333V23.167A2.333,2.333,0,0,1,23.167,25.5Z",
					fill: "none",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_805",
					"data-name": "Path 805",
					d: "M22.865,30V19.5H10.5V30",
					transform: "translate(-1.683 -4.5)",
					fill: "none",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_806",
					"data-name": "Path 806",
					d: "M10.5,4.5V9.751h9.634V4.5",
					transform: "translate(-1.682)",
					fill: "none",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1
				})
			]
		})
	})
});
export default SvgSaveExperiment;
